import { UserSettings } from '../../models/user-settings';
import { InjectionToken } from '@angular/core';

export interface StorageProvider {
    getState(): Promise<UserSettings>;
    setState(state: UserSettings): Promise<void>;
    clearState(): Promise<void>;
}

// Create an InjectionToken for the StorageProvider interface
export const STORAGE_PROVIDER = new InjectionToken<StorageProvider>('StorageProvider');